<template>
    <v-card class="stage-grid-review" elevation="0">
    
        <v-container fluid class="py-6 px-0">
            <!-- [{
                "id": "d9e81931-5c25-42b2-84e1-6660fc716453",
                "module_id": "44edf507-bf73-4859-8ee0-237e66633b78",
                "stage_name": "Complete Questionnaire",
                "stage_desc": "Please complete your Equity questionnaire. Answer each question as accurately as possible, the overall success of your documents are dependent upon you answering as fully and precisely as possible. <i>If you are unable to complete this questionnaire, please email us at <a mailto:\"info@successionresourcegroup.com\">info@successionresourcegroup.com</a> or call us at (503) 427 9910 to discuss your options.</i>",
                "stage_order": 1,
                "is_active": true,
                "created_date": "2023-07-13T06:58:40.475Z",
                "stage_type": "general",
                "extra_details": null,
                "is_independent": null,
                "is_primary": null
            }] -->

            <!-- Grid Header -->
            <v-row class="caption lighten-3 py-3 px-0 ma-0">
                <!-- Always Visible Columns -->
                <v-col cols="1" class="px-2 py-0">Order</v-col>
                <v-col cols="3" class="px-2 py-0">Name</v-col>
                <v-col cols="5" class="px-2 py-0">Description</v-col>

                <!-- Admin Only Columns -->
                <v-col v-if="canEdit" cols="2" class="d-flex justify-end px-2 py-0">Type</v-col>
                <!-- <v-col v-if="canEdit" cols="2" class="d-flex justify-center px-2 py-0">Extra</v-col> -->

                <v-col :cols="canEdit ? '1' : '3'" class="d-flex justify-center px-2 py-0">Active</v-col>
            </v-row>

            <v-divider></v-divider>

            <!-- Data Rows -->
            <v-row 
                v-for="(stage, index) in stages" 
                :key="stage.stage_order" 
                dense 
                class="py-3 px-0 ma-0 stage-row"
                :class="index % 2 === 0 ? 'white' : 'grey lighten-4'">

                <!-- Column 1: stage_order -->
                <v-col cols="1" class="px-2">
                    {{ stage.stage_order }}
                </v-col>

                <!-- Column 2: stage_name -->
                <v-col cols="3" class="px-2">
                    {{ stage.stage_name }}
                </v-col>

                <!-- Column 3: stage_desc -->
                <v-col cols="5" class="px-2">
                    <span :title="stage.stage_desc" v-html="stage.stage_desc"></span>
                </v-col>

                <!-- Column 4: stage_type (Admin Only) -->
                <v-col v-if="canEdit" cols="2" class="px-2 d-flex justify-end align-start">
                    <v-chip small outlined color="primary">{{ stage.stage_type }}</v-chip>
                </v-col>

                <!-- Column 5: extra_details (Admin Only) -->
                <!-- <v-col v-if="canEdit" cols="1" class="d-flex justify-center px-2">
                    <span :title="JSON.stringify(stage.extra_details)">
                        {{ stage.extra_details }}
                    </span>
                </v-col> -->

                <!-- Column 6: is_active (Status) -->
                <v-col :cols="canEdit ? '1' : '3'" class="d-flex justify-center align-start px-2">
                    <v-icon v-if="stage.is_active" color="primary">mdi-check-circle</v-icon>
                    <v-icon v-else color="grey">mdi-circle-outline</v-icon>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
    export default {
    name: 'RoadmapDisplay',
    
    props: {
        stages: Array,
        canEdit: Boolean
    }
};
</script>

<style scoped>
    .stage-grid-review {
        max-width: 100%;
    }

    .stage-row {
        transition: background-color 0.2s ease;
        border-bottom: 1px solid #eee;
    }

    .stage-row:hover {
        background-color: #e6e6e6 !important;
    }

    .text-truncate {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/roadmapDisplay.vue